import { Box, Grid2, Paper } from "@mui/material";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import { useNavigate } from "react-router-dom";
import { DividendosTablaDto } from "../models/dividendosTablaForm";
import UseColumnasTablaImportacion from "../utils/columnsTablaImportacion";
import { useMemo } from "react";
import Tabla from "../../../../components/ui/materialui/tabla";

interface IProps {
    isSubmitEnabled: boolean;
    dividendos: DividendosTablaDto[]
    onCancel: () => void;
    isShowing: boolean
}

export const DividendosImportForm = ({isSubmitEnabled, dividendos, onCancel, isShowing} : IProps) => {

    const { COLUMNS_IMPORTACION } = UseColumnasTablaImportacion();
    const columns = useMemo(() => COLUMNS_IMPORTACION, [])
    
    
    return (
        <>
            <CustomAccordion
                title={isShowing ? 'Dividendos' : 'Dividendos a importar'}
                expandedDefault
            >
                <Tabla
                    data={dividendos}
                    columns={columns}
                />
            </CustomAccordion>
            <Grid2 size={4} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginTop: "15px" }}>
                <MButton variant="contained" color="inherit" onClick={onCancel}>
                    Cancelar
                </MButton>
                <MButton type="submit" variant="contained" color="primary" style={{marginLeft: "10px"}} disabled={!isSubmitEnabled}>
                    { isShowing ? 'Exportar' : 'Grabar '}
                </MButton>
            </Grid2>
        </>
    )
}